import React from 'react';
import s from './s.modules.less';
import PrinceFrame from '../imgs/PrinceFrame.png';
import { Button } from 'antd';
import { BenefitsTag1, BenefitsTag2, PricingCheckCircleSVG } from './svg';
import FrequencyQuestionSecion from 'components/FrequencyQuestionSecion';
import { FAQData } from './constants';
import classNames from 'classnames';

export enum ESection {
    BENEFITS = 'benefits',
    FAQ = 'faq',
    PRICING = 'pricing',
    HOW_IT_WORKS = 'how',
}

export const Benefits = () => {
    return (
        <div className={s.wrap} id={ESection.BENEFITS}>
            <h2 className={s.title}>Why use Klarity Meet</h2>
            <p className={s.desc}>
                Klarity Meet removes all the duct tape from caring patients from Klarity. Every appointment gets its own
                secure video link. Patients join from their usual Klarity reminders. You stay in one clean workspace,
                instead of juggling different apps, and copy-pasted URLs.
            </p>
            <h2 className={s.title}>What you get today</h2>
            <div className={s.benefitRow}>
                <div className={classNames(s.benefitItem, s.benefitItem1)}>
                    <div className={s.benefitTitle}>Free and no need to pay</div>
                    <div className={s.benefitDescription}>
                        Patients wait in a simple, branded waiting room until you admit them. Keep your schedule running
                        smoothly.
                    </div>
                </div>
                <div className={classNames(s.benefitItem, s.benefitItem2)}>
                    <div className={s.benefitTitle}>Everything in one workspace</div>
                    <div className={s.benefitDescription}>
                        See the patient, review intake answers, chart visit notes, and send e-prescriptions-all from
                        your Provider Portal.
                    </div>
                </div>
            </div>
            <div className={s.benefitRow}>
                <div className={classNames(s.benefitItem, s.benefitItem3)}>
                    <div className={s.benefitTitle}>HIPAA-Secure & built-in</div>
                    <div className={s.benefitDescription}>
                        Run telehealth visits directly inside Klarity. Patients join from any browser-no downloads, no
                        extra logins required.
                    </div>
                </div>
                <div className={classNames(s.benefitItem, s.benefitItem4)}>
                    <div className={s.benefitTitle}>Zero admin work</div>
                    <div className={s.benefitDescription}>
                        We auto-generate secure links for every appointment and send them via SMS & Email automatically.
                    </div>
                </div>
            </div>
            <div className={s.benefitFullRow}>
                <div className={classNames(s.benefitItem, s.benefitItem5)}>
                    <div className={s.benefitItemComingSoon}>Coming soon</div>
                    <div className={s.benefitTitle}>The only platform ready for AI Scribing</div>
                    <div className={s.benefitDescription}>
                        Your current video tool (Doxy/Zoom) can't write your notes for you. Klarity Meet is built to be
                        the foundation for our upcoming AI Scribe. Switch now so you are ready when it launches.
                    </div>
                    <div className={s.benefitItemTag}>
                        <div className={s.benefitItemTagItem}>{BenefitsTag1}Auto-Transcription</div>
                        <div className={s.benefitItemTagItem}>{BenefitsTag2}AI note generation</div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export const HowItWork = () => {
    const items = [
        {
            title: 'Go to Settings',
            description: 'Find the ‘Video Visit’ tab in your provider portal settings',
        },
        {
            title: 'Select Klarity Meet',
            description: 'Set it as your default. You can switch back anytime.',
        },
        {
            title: 'Schedule & Go',
            description: 'Create an appointment. The link is handled for you.',
        },
    ];
    return (
        <div className={s.wrap} id={ESection.HOW_IT_WORKS}>
            <h2 className={s.title}>How it works</h2>
            <div className={s.borderTop} />
            <div className={s.list}>
                {items.map((item, inx) => {
                    return (
                        <div className={s.item} key={inx}>
                            <div className={s.number}>{inx + 1}</div>
                            <div className={s.subTitle}>{item.title}</div>
                            <div className={s.itemDescription}>{item.description}</div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export const Pricing = (props: { onGetStarted: () => void }) => {
    return (
        <div className={s.wrap} id={ESection.PRICING}>
            <h2 className={s.title}>Pricing & Fee</h2>
            <div className={s.pricing}>
                <div className={s.pricingContent}>
                    <div className={s.pricingTitle}>Completely free for providers</div>
                    <div className={s.pricingDescription}>
                        Klarity meet is included in your Klarity platform. No hidden fees.
                    </div>
                    <div>
                        <ul>
                            <li>{PricingCheckCircleSVG}No extra telehealth licenses</li>
                            <li>{PricingCheckCircleSVG}No per-meeting video fees</li>
                            <li>{PricingCheckCircleSVG}Unlimited duration</li>
                        </ul>
                        <Button
                            type="primary"
                            shape="round"
                            onClick={() => {
                                props.onGetStarted();
                            }}
                        >
                            Get started now
                        </Button>
                    </div>
                </div>
                <img className={s.pricingFrame} src={PrinceFrame} />
            </div>
        </div>
    );
};

export const FAQ = () => {
    return (
        <div className={s.wrap} id={ESection.FAQ}>
            <h2 className={s.title}>Frequently asked questions</h2>
            <div className={s.faqContent}>
                <div className={s.faqTitle}>What is Klarity Pay Later?</div>
                <div className={s.faqDescription}>
                    Klarity Pay Later is Klarity’s financing program, powered by Kanmon, that helps healthcare providers
                    accelerate the growth of their practice. It offers short-term, low-fee advances to cover Klarity
                    marketing services such as Prolisting and Standard Listings.
                </div>
                <FrequencyQuestionSecion openAll={false} data={FAQData} largerFontsize />
            </div>
        </div>
    );
};
